export default __webpack_public_path__ + "static/media/cloudfactory-clients.5d810772.webp";